import { useApiConfig } from '../useApiConfig';

import { IAS_PROJECTS_QUERY_KEY } from '../../utils/consts';
import { useQueryClient } from '@tanstack/react-query';
import {
  InfrastructureInstancesApi,
  InfrastructureInstanceActionsCreationRequest,
} from 'osep-generator-service-client-v1';

function usePerformInfrastructureInstanceActionMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const queryClient = useQueryClient();

  const performInfrastructureInstanceAction = async (
    id: string,
    action: InfrastructureInstanceActionsCreationRequest,
  ) => {
    const config = await getApiConfig();
    const api = new InfrastructureInstancesApi(
      config,
      undefined,
      axiosInstance,
    );

    const response = await api.performInfrastructureInstanceAction(id, action);
    await queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.includes(IAS_PROJECTS_QUERY_KEY),
    });

    return response.data;
  };

  return { performInfrastructureInstanceAction };
}

export default usePerformInfrastructureInstanceActionMutation;
